import React, { useState, useEffect } from 'react';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/`;
}

export default function VisitorMemory() {
  const [message, setMessage] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const lastVisit = getCookie('mekhal_last_visit');
    const visitCount = parseInt(getCookie('mekhal_visit_count') || '0');
    const lastPath = getCookie('mekhal_last_path');

    const now = new Date().toISOString();
    setCookie('mekhal_last_visit', now, 365);
    setCookie('mekhal_visit_count', String(visitCount + 1), 365);

    if (lastVisit && visitCount > 0) {
      const daysSince = Math.floor((Date.now() - new Date(lastVisit).getTime()) / (1000 * 60 * 60 * 24));

      let msg = 'Welcome back';
      if (daysSince === 0) msg = "Back again today — glad you're here.";
      else if (daysSince === 1) msg = "Welcome back — you were here yesterday.";
      else if (daysSince < 7) msg = `Welcome back — it's been ${daysSince} days.`;
      else if (daysSince < 30) msg = `Welcome back — it's been a few weeks.`;
      else msg = `Good to see you again — it's been a while.`;

      if (lastPath) msg += ` Last time you explored the ${lastPath} view.`;

      setMessage(msg);
      setTimeout(() => setVisible(true), 500);
      setTimeout(() => setVisible(false), 6000);
    }
  }, []);

  // Track which path was chosen
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const pathEl = document.querySelector('[data-path]');
      if (pathEl) {
        setCookie('mekhal_last_path', pathEl.getAttribute('data-path'), 365);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  if (!message) return null;

  return (
    <div style={{
      position: 'fixed', top: '80px', left: '50%', transform: 'translateX(-50%)',
      zIndex: 1100, pointerEvents: 'none',
      opacity: visible ? 1 : 0,
      transition: 'opacity 0.6s ease',
    }}>
      <div style={{
        fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.15em',
        color: 'var(--ink)', background: 'var(--bg)',
        border: '1px solid rgba(26,26,26,0.12)',
        padding: '10px 20px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
      }}>
        <span style={{ color: 'var(--accent)', marginRight: '8px' }}>●</span>
        {message}
      </div>
    </div>
  );
}
